import { InjectionToken } from '@angular/core';

/**
 * Whether the auth pages (login / 2FA / reset-password / register) fetch and
 * render the content slider from `/data/slides-*.json`.
 *
 * Defaults to `true` so the dashboard keeps working with no extra providers.
 * Apps that don't ship a slides config (e.g. the partner portal) provide
 * `false`, which makes `AuthSliderService` short-circuit — no HTTP request,
 * and the slider column stays hidden (templates gate on `sliderConfig?.length`).
 */
export const AUTH_SLIDES_ENABLED = new InjectionToken<boolean>('AUTH_SLIDES_ENABLED', {
  providedIn: 'root',
  factory: (): boolean => true,
});
